import { apiPeUrl } from '@/environment/environment';

export const apiConstants = {
  fetchGuide: 'mock-data/competer/guide.json',
  fetchTags: 'mock-data/competer/tags.json',
  fetchArtefacts: 'mock-data/competer/artefacts.json',
  fetchArtefact: 'mock-data/competer/artefact.json',
  fetchArtifactUnit: 'mock-data/competer/artefactUnit.json',
  dash: apiPeUrl+'productbase/overview',
  stock: apiPeUrl+'apis/search',
  stocksearch: apiPeUrl+'productbase/v2/search',
  scf: apiPeUrl+'apis/search',
  srf: apiPeUrl+'apis/search',
  cdl: apiPeUrl+'apis/search',
  bdl: apiPeUrl+'apis/search',
  sku: apiPeUrl+'productbase/sku',
  mpi: apiPeUrl+'productbase/recheck',
  cpi: apiPeUrl+'productbase/levispriceindex/category',
  gpi: apiPeUrl+'productbase/levispriceindex/gender',
  spi: apiPeUrl+'productbase/levispriceindex/color',
  pga: apiPeUrl+'productbase/getmetrics',
  // amb: apiPeUrl+'productbase/levispriceindex/color',
  // cpi: 'mock-data/competer/cpi.json',
  // gpi: 'mock-data/competer/gpi.json',
  // spi: 'mock-data/competer/spi.json',
  amb: 'mock-data/competer/amb.json',

  upload: apiPeUrl+'productbase/upload',
  download: apiPeUrl+'productbase/download',

  
  // dash: 'mock-data/competer/overview_v2.json',
  // stock: 'mock-data/competer/stock_v2.json',
  // sku: 'mock-data/competer/sku_v2.json'
};
